// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "5ff4eacd5bd786dc4a11d338c1d9c18b244bc09d/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};